import React from 'react';
import {Box,} from '@mui/material';
import ContactModalForm from "./ContactModalForm";
import {useLanguage} from "../../LanguageContext";

const ContactSection = ({open, setOpen}) => {
    const {t} = useLanguage();

    const handleClose = () => setOpen(false);

    return (
        <Box>
            <ContactModalForm open={open} onClose={handleClose}/>
        </Box>
    );
};

export default ContactSection;

